import MailIcon from '@mui/icons-material/Mail'
import { Link as AccountLink, styled, Typography } from '@mui/material'
import Badge from '@mui/material/Badge'
import { Box } from '@mui/system'
import dayjs from 'dayjs'
import i18n from 'i18next'
import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import Account from './Account/Account'
import SelectLang from './SelectLang'
import ThemeContainer from './ThemeContainer/ThemeContainer'
import { getLangLink } from '../../../helpers'
import { useDefaultComponentTools } from '../../../hooks/useDefaultComponentTools'
import { setShowLoginPopup } from '../../../store/redusers/auth/actions'
import { selectLogoUrl, selectMessages, selectPlatformLang, selectUserId } from '../../../store/redusers/user/selectors'
import AppButton from '../../AppButton'
import AppPopup from '../../AppPopup'


const DepositIframe = styled('iframe')(() => ({
	border: 'none',
	height: '500px',
	width: '100%'
}))

const LogoImg = styled('img')(() => ({
	maxHeight: '25px'
}))

export const BoxControl = styled(Box)(({ theme }) => ({
	alignItems: 'center',
	display: 'flex',
	gap: '16px',
	justifyContent: 'space-between',
	[theme.breakpoints.down('md')]: {
		flexWrap: 'wrap',
		gap: '6px',
		justifyContent: 'space-around',
		width: '100%'
	}
}))

const Header = ({setHeaderHeight}) => {
	const isAuthorized = useSelector(selectUserId)
	const { alert, dispatch, theme, mdUp, t } = useDefaultComponentTools()
	const [isDeposit, setIsDeposit ] = useState(false)
	const platformLang = useSelector(selectPlatformLang)
	const logoUrl = useSelector(selectLogoUrl)
	const messages = useSelector(selectMessages)
	const elementRef = useRef(null)
	const utc = require('dayjs/plugin/utc')
	const timezone = require('dayjs/plugin/timezone')
	dayjs.extend(utc)
	dayjs.extend(timezone)
	const [date, setDate] = useState(dayjs.tz(new Date(), 'GMT').format('h:mm a'))

	const refreshClock = () => setDate(dayjs.tz(new Date(), 'GMT').format('h:mm a') + ' GMT')

	useEffect(() => {
		const timerId = setInterval(refreshClock, 1000)
		return function cleanup() {
			clearInterval(timerId)
		}
	}, [])

	useEffect(() => {
		const element = elementRef?.current
		if (!element) return
		const observer = new ResizeObserver(() => {
			setHeaderHeight(element.clientHeight)
		})
		observer.observe(element)
		return () => {
			observer.disconnect()
		}
	}, [])

	const onShowMsgs = () => {
		if (!messages?.length) return
		alert.removeAll()
		messages.forEach(msg =>	alert.info(msg.messageText, {loader: false, message: msg, timeout: 0}))
	}

	return (
		<Box ref={elementRef} sx={{
			background: theme.palette.second,
			display: 'flex', gap: mdUp ? '16px' : '8px',
			justifyContent: 'space-between',
			p:  '8px',
			[theme.breakpoints.down('md')]: {
				flexDirection: 'column',
				position: 'fixed',
				top: 0,
				width: '100%',
				zIndex: 5
			}
		}}>
			<Box href={getLangLink('/' , i18n.language.toLowerCase())} component={AccountLink} >
				<LogoImg src={logoUrl} alt='logo'/>
			</Box>
			{isAuthorized ?
				<BoxControl >
					<Typography title={'version=' + process.env.REACT_APP_VERSION}>{date}</Typography>
					<Badge  badgeContent={messages?.length} color='primary' onClick={onShowMsgs}>
						<MailIcon color={theme.palette.text.secondary}/>
					</Badge>
					<SelectLang />
					<AppButton inputSx={{background: theme.palette.blue, height: mdUp ? '40px' : '35px',
						textTransform: 'capitalize', width: mdUp ? '120px' : '100px'
					}} title={t('Deposit')} variant='contained' onClick={() => setIsDeposit(true)}
					/>
					{!isDeposit ? null :<AppPopup
						setOpenedComponent={() => setIsDeposit(false)}
						title={t('Deposit funds')}
					>
						<DepositIframe
							title='deposit'
							src={window.TRADING_APP_FRONT_URL + platformLang + '/page-deposit-popup/'}
						/>
					</AppPopup>}
					<ThemeContainer />
					<Account />

				</BoxControl>
				:
				<BoxControl>
					<AppButton inputSx={{background: theme.palette.blue, height: mdUp ? '40px' : '35px',
						textTransform: 'capitalize', width: mdUp ? '120px' : '100px'
					}} onClick={() => dispatch(setShowLoginPopup(true))} title={t('Sign In')} variant='contained'
					/>
					<AppButton inputSx={{background: theme.palette.blue, height: mdUp ? '40px' : '35px',
						textTransform: 'capitalize', width: mdUp ? '120px' : '100px'
					}}  link={getLangLink('/open-account/' , i18n.language.toLowerCase())} title={t('Register')} variant='contained'
					/>
					<ThemeContainer />
					<SelectLang />
				</BoxControl>
			}
		</Box>
	)
}

Header.propTypes = {
	setHeaderHeight: PropTypes.func
}


export default Header
